import PropTypes from 'prop-types';
import React from 'react';
import {
    CLOUDINARY,
    YOUTUBE,
} from '../../../../pages/CompanyPages/CompanyOverview/CompanyOverview';
import ResponsiveVideo from '../../../Elements/ResponsiveVideo/ResponsiveVideo';
import './VideoPlayer.scss';

export default class VideoPlayer extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        videoType: PropTypes.oneOf(['cloudinary', 'youtube']),
        videoSrc: PropTypes.string,
        fullWidth: PropTypes.bool,
        responsiveVideoProps: PropTypes.shape({
            height: PropTypes.number,
            width: PropTypes.number,
            emitMetric: PropTypes.bool,
        }),
    };

    static defaultProps = {
        responsiveVideoProps: {
            width: 1600,
            height: 900,
        },
    };

    renderYouTubeVideo() {
        return (
            <iframe
                className="youtube-video"
                src={this.props.videoSrc}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
            ></iframe>
        );
    }

    renderCloundinaryVideo() {
        const { responsiveVideoProps, videoSrc } = this.props;
        return (
            <ResponsiveVideo
                {...responsiveVideoProps}
                cloudinaryID={videoSrc}
                enableAutoResizing={false}
            />
        );
    }

    render() {
        const iframeClass =
            this.props.videoType === YOUTUBE ? 'iFrame-container' : '';
        return (
            <div
                className={`component-CompanyPages-Sections-VideoPlayer ${iframeClass} ${
                    this.props.fullWidth ? 'full-width' : ''
                }`}
            >
                {this.props.videoType === YOUTUBE
                    ? this.renderYouTubeVideo()
                    : this.renderCloundinaryVideo()}
            </div>
        );
    }
}
